export default __webpack_public_path__ + "./images/ma.6cc90ba6.svg";